import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    shows: [],
    showsMetadata: {},
    show: {},
    showEpisodes: [],
    showContentLabels: [],
    showPairingTemplates: []
  }
})
  .get({
    action: 'getShows',
    property: 'shows',
    queryParams: true,
    path: '/shows/',
    onSuccess: payloadToState('shows')
  })
  .post({
    action: 'createShow',
    property: 'show',
    path: '/shows/',
    onSuccess: payloadToState('show')
  })
  .get({
    action: 'getShow',
    property: 'show',
    queryParams: true,
    path: ({ id }) => `/shows/${id}`,
    onSuccess: payloadToState('show')
  })
  .put({
    action: 'updateShow',
    property: 'show',
    path: ({ id }) => `/shows/${id}`,
    onSuccess: payloadToState('show')
  })
  .delete({
    action: 'deleteShow',
    property: 'shows',
    path: ({ id }) => `/shows/${id}`,
    beforeRequest: getOptimisticDelete('shows'),
    onSuccess: payloadToState('show')
  })
  .delete({
    action: 'deleteShows',
    property: 'shows',
    path: `/shows/`,
    queryParams: true,
    beforeRequest: getOptimisticDelete('shows'),
    onSuccess: payloadToState('shows')
  })
  .get({
    action: 'getShowEpisodes',
    property: 'showEpisodes',
    path: ({ id }) => `/shows/${id}/episodes`,
    onSuccess: payloadToState('showEpisodes')
  })
  .get({
    action: 'getShowContentLabels',
    property: 'showContentLabels',
    path: ({ id }) => `/shows/${id}/content-labels`,
    onSuccess: payloadToState('showContentLabels')
  })
  .get({
    action: 'getShowPairingTemplates',
    property: 'showPairingTemplates',
    path: ({ id }) => `/shows/${id}/pairing-templates`,
    onSuccess: payloadToState('showPairingTemplates')
  })
  .get({
    action: 'getExternalDbShows',
    property: 'externalShows',
    queryParams: true,
    path: `/external-db-shows`
  })
  .get({
    action: 'getExternalDbShow',
    property: 'externalShows',
    queryParams: true,
    path: ({ id }) => `/external-db-shows/${id}`
  })
  .getStore()
